import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getRoleList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles`,
    method: 'get',
    params: {},
  });
}

export function findRole(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles/${ id }`,
    method: 'get',
    params: {},
  });
}

export function saveRole(role) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles`,
    method: 'post',
    data: role,
  });
}

export function updateRole(role) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles`,
    method: 'patch',
    data: role,
  });
}

export function delRole(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roles/${ id }`,
    method: 'delete',
  });
}

export function findRoleMenu(roleId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roleMenu/${ roleId }`,
    method: 'get',
  });
}

export function saveRoleMenu(roleId, menuIds) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/roleMenu/${ roleId }`,
    method: 'post',
    data: menuIds,
  });
}
